/* istanbul ignore file */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
import { FormattedMessage as NotTypedFormattedMessage, type FormattedMessageProps } from '@ori/i18n';

import type { DefaultTranslations } from '../constants/defaultTranslations';

/**
 * Renders a formatted internationalized message using the provided translation data.
 *
 * @returns The FormattedMessage typed with keys within the specified namespace.
 */
export const FormattedMessage = (props: FormattedMessageProps<DefaultTranslations>) => (
  <NotTypedFormattedMessage<DefaultTranslations> {...props} />
);
